<template>
  <div class="pd20x flex1">
    <div class="contentBox h100pct ofA">
      <div class="filter" style="padding:10px 20px; display: flex; align-items: center;">
        <label>搜索兑换码：</label>
        <a-input-search
          v-model="filter.keywords"
          placeholder="搜索兑换码"
          style="width: 250px"
          @search="searchData"
          class="mr10px"
        />
      </div>

      <a-table
        :columns="columns"
        :data-source="data"
        :pagination="pagination"
        :loading="loading"
        rowKey="id"
        @change="changePage"
      >
        <template slot="bag_name" slot-scope="text, record">
          <a href="javascript:;" @click="showDetail(record)" style="max-width: 180px; display: inline-block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; vertical-align: middle;" :title="text">
            {{ text || '-' }}
          </a>
        </template>
        <template slot="use_time" slot-scope="text">
          <span>{{ text > 0 ? formatDate(text * 1000) : '-' }}</span>
        </template>
        <template slot="create_time" slot-scope="text">
          <span>{{ formatDate(text * 1000) }}</span>
        </template>
        <template slot="use_nickname" slot-scope="text, record">
          <span>{{ text ? `${text} (ID: ${record.use_uid})` : '-' }}</span>
        </template>
      </a-table>
    </div>

    <!-- 关联详情弹窗 -->
    <a-modal
      title="关联试卷详情"
      :visible="detailVisible"
      @ok="detailVisible = false"
      @cancel="detailVisible = false"
      :footer="null"
      destroyOnClose
      width="500px"
    >
      <a-list size="small" bordered :data-source="detailList">
        <a-list-item slot="renderItem" slot-scope="item">
          <a-tag :color="item.type === 'bag' ? 'blue' : 'green'">
            {{ item.type === 'bag' ? '套卷' : '单卷' }}
          </a-tag>
          <span style="font-weight: 500;">{{ item.name }}</span>
        </a-list-item>
      </a-list>
    </a-modal>
  </div>
</template>

<script>
import * as http from '@/libs/examapi'
import { formatDate } from '@/libs/moment'

const columns = [
  {
    title: '兑换码',
    dataIndex: 'code',
    align: 'center'
  },
  {
    title: '关联套卷',
    dataIndex: 'bag_name',
    scopedSlots: { customRender: 'bag_name' },
    align: 'center'
  },
  {
    title: '兑换者',
    dataIndex: 'use_nickname',
    scopedSlots: { customRender: 'use_nickname' },
    align: 'center'
  },
  {
    title: '使用时间',
    dataIndex: 'use_time',
    scopedSlots: { customRender: 'use_time' },
    align: 'center'
  },
  {
    title: '生成时间',
    dataIndex: 'create_time',
    scopedSlots: { customRender: 'create_time' },
    align: 'center'
  }
]

export default {
  name: 'redeemRecordList',
  data () {
    return {
      columns,
      data: [],
      loading: false,
      filter: {
        keywords: ''
      },
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
        showTotal: total => `共 ${total} 条`
      },
      detailVisible: false,
      detailList: [],
      bagMap: {},
      paperMap: {}
    }
  },
  mounted () {
    this.getData()
    this.getTreeData()
  },
  methods: {
    formatDate,
    getData () {
      this.loading = true
      const params = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        keywords: this.filter.keywords,
        status: 1 // 强制只查询已使用的记录（即兑换记录）
      }
      http.getRedeemCodes(params).then(res => {
        this.data = res.data
        const pagination = { ...this.pagination }
        pagination.total = res.total
        this.pagination = pagination
        this.loading = false
      }).catch(err => {
        console.error(err)
        this.loading = false
        this.$message.error('获取兑换记录失败')
      })
    },
    searchData () {
      const pagination = { ...this.pagination }
      pagination.current = 1
      this.pagination = pagination
      this.getData()
    },
    changePage (pagination) {
      const pag = { ...this.pagination }
      pag.current = pagination.current
      this.pagination = pag
      this.getData()
    },
    showDetail (record) {
      const list = []
      let parsed = null
      
      if (record.relation_data) {
        try {
          parsed = JSON.parse(record.relation_data)
        } catch (e) {
          console.error('解析 relation_data 失败', e)
        }
      }

      if (parsed) {
        if (parsed.bags && parsed.bags.length > 0) {
          parsed.bags.forEach(bId => {
            const title = this.bagMap[bId] || `套卷 (ID: ${bId})`
            list.push({ type: 'bag', name: title })
          })
        }
        if (parsed.papers && parsed.papers.length > 0) {
          parsed.papers.forEach(pId => {
            const name = this.paperMap[pId] || `单卷 (ID: ${pId})`
            list.push({ type: 'paper', name: name })
          })
        }
      }

      if (list.length === 0 && record.bag_name) {
        // 兼容降级
        list.push({ type: 'bag', name: record.bag_name })
      }

      this.detailList = list
      this.detailVisible = true
    },
    getTreeData () {
      const p1 = http.get_crouse_list({ page: 1, pageSize: 1000, detail_type: 1 })
      const p2 = http.getExam({ cate_id: null })
      
      Promise.all([p1, p2]).then(([res1, res2]) => {
        const bags = res1.data || []
        const papers = res2 || []
        
        const bagMap = {}
        bags.forEach(bag => {
          bagMap[bag.id] = bag.title
        })
        this.bagMap = bagMap

        const paperMap = {}
        papers.forEach(p => {
          paperMap[p.id] = p.name
        })
        this.paperMap = paperMap
      }).catch(err => {
        console.error('初始化数据字典 Map 失败:', err)
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
